<div class="full-screen overflow-hidden">
    <div class="d-flex flex-grow-1">

        <!-- CHOOSE BRANCH SIDE -->
        <div class="zx-settings-nav flex-shrink h-100 d-flex flex-column overflow-hidden"
            [class.zx-settings-nav-dark]="isDarkMode">
            <article class="w-100 h-100 d-flex p-3 flex-column overflow-auto">
                <article class="w-100 d-flex flex-column gap-2 flex-grow-1">

                    <app-navigation-to-branches></app-navigation-to-branches>

                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0 zx-text-small fw-bold zx-text-sm-medium">
                            {{'choose-system.step-2' | translate}}
                        </h6>
                    </div>

                    <!-- Loading BRANCHES BTNS  -->
                    <div *ngIf="isLoading" class="w-100 d-flex flex-grow-1 justify-content-center align-items-center">
                        <mat-spinner class="zx-small-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
                    </div>
                    <!-- // Loading BRANCHES BTNS  -->

                    <!-- BRANCHES BTNS -->
                    <div *ngIf="cluster && !isLoading" class="w-100 d-flex flex-column">
                        <!-- PLOTTER -->
                        <div #branchElement class="d-flex w-100"
                            *ngFor="let createdBranch of cluster.plotter; let i = index">
                            <div (click)="onChooseBranch(createdBranch.serial_name, 'plotter')"
                                (mouseenter)="onHoverPrintingService('plotter')"
                                (mouseleave)="onHoverPrintingService('')"
                                [class.zx-step-choosen]="branch === createdBranch.serial_name && printingService === 'plotter'"
                                [class.zx-step-effect]="branch === createdBranch.serial_name && printingService === 'plotter' && isAnimateBranchBtn"
                                class="step-item step-item-hover w-100 mt-2 rounded-3 shadow-85 d-flex flex-column flex-sm-row align-items-sm-center gap-3 p-2"
                                matRipple [matRippleDisabled]="!isScreenWide" [class.step-item-dark]="isDarkMode">
                                <div class="d-none d-sm-flex rounded-2 zx-big-icon-size p-3 mx-1 zx-border-gray-v-light"
                                    [class.bg-light-darkmode]="isDarkMode">
                                    <img [src]="'assets/images/plotter-icon.svg'" [alt]="'plotter printer'"
                                        class="w-100 h-100">
                                </div>
                                <div class="d-flex flex-column h-100 justify-content-between py-2">
                                    <div class="d-flex align-items-center gap-2">
                                        <div [class.bg-light-darkmode]="isDarkMode"
                                            class="d-flex d-sm-none rounded-circle zx-medium-small-icon-size zx-border-gray-v-light p-2">
                                            <img [src]="'assets/images/plotter-icon.svg'" [alt]="'plotter printer'"
                                                class="w-100 h-100">
                                        </div>
                                        <div [class.bg-light-darkmode]="isDarkMode"
                                            class="d-flex rounded-circle zx-medium-small-icon-size zx-border-gray-v-light p-1">
                                            <img [src]="'assets/images/branches/' + createdBranch.serial_name + '.png'"
                                                [alt]="createdBranch.serial_name  + ' Logo'" class="w-100 h-100">
                                        </div>
                                        <h6 class="fw-bold mb-0 mb-sm-2 zx-text-big"
                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                            {{ "choose-branch.naming.plotter." + createdBranch.serial_name | translate
                                            }}
                                        </h6>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <span class="opacity-75 zx-text-small"
                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                            {{ "choose-system.explanation-plotter" | translate }}
                                        </span>
                                    </div>
                                    <div class="d-flex w-100 zx-text-tiny zx-text-sm-small text-green opacity-75">
                                        <b>
                                            <span>
                                                {{ "main-nav.super-management-papers" | translate }}
                                            </span>
                                            <span>
                                                :
                                            </span>
                                        </b>
                                        <span class="zx-100-opp">-</span>
                                        <ng-container
                                            *ngFor="let paper of createdBranch.printers[0].inputBins; let j = index">
                                            <div class="d-flex align-items-center">
                                                <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                    class="text-center">
                                                    {{ "paper-type.name-short." + paper.paperType.paperType | translate
                                                    }}
                                                </span>
                                                <span *ngIf="createdBranch.printers[0].inputBins.length !== j + 1">
                                                    ,
                                                </span>
                                                <span class="zx-100-opp">-</span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- // PLOTTER -->
                        <!-- EXPRESS -->
                        <div #branchElement class="d-flex w-100"
                            *ngFor="let createdBranch of cluster.express; let i = index">
                            <div (click)="onChooseBranch(createdBranch.serial_name, 'express')"
                                (mouseenter)="onHoverPrintingService(getIsPics(createdBranch))"
                                (mouseleave)="onHoverPrintingService('')"
                                [class.zx-step-choosen]="branch === createdBranch.serial_name && printingService === 'express'"
                                [class.zx-step-effect]="branch === createdBranch.serial_name && printingService === 'express' && isAnimateBranchBtn"
                                class="step-item step-item-hover w-100 mt-2 rounded-3 shadow-85 d-flex flex-column flex-sm-row align-items-sm-center gap-3 p-2"
                                matRipple [matRippleDisabled]="!isScreenWide" [class.step-item-dark]="isDarkMode">
                                <div class="d-none d-sm-flex rounded-2 zx-big-icon-size p-3 mx-1 zx-border-gray-v-light"
                                    [class.bg-light-darkmode]="isDarkMode">
                                    <img [src]="'assets/images/' + getIsPics(createdBranch) + '-icon.svg'"
                                        [alt]="'images and docs printer'" class="w-100 h-100">
                                </div>
                                <div class="d-flex flex-column h-100 justify-content-between py-2">
                                    <div class="d-flex align-items-center gap-2">
                                        <div [class.bg-light-darkmode]="isDarkMode"
                                            class="d-flex d-sm-none rounded-circle zx-medium-small-icon-size zx-border-gray-v-light p-2">
                                            <img [src]="'assets/images/' + getIsPics(createdBranch) + '-icon.svg'"
                                                [alt]="'images and docs printer'" class="w-100 h-100">
                                        </div>
                                        <div [class.bg-light-darkmode]="isDarkMode"
                                            class="d-flex rounded-circle zx-medium-small-icon-size zx-border-gray-v-light p-1">
                                            <img [src]="'assets/images/branches/' + createdBranch.serial_name + '.png'"
                                                [alt]="createdBranch.serial_name  + ' Logo'" class="w-100 h-100">
                                        </div>
                                        <h6 class="fw-bold mb-0 mb-sm-2 zx-text-big"
                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                            {{ "choose-branch.naming.express." + createdBranch.serial_name | translate
                                            }}
                                        </h6>
                                    </div>
                                    <div class="d-flex flex-column align-items-start">
                                        <span class="opacity-75 zx-text-small"
                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                            {{ "choose-system.explanation-" + getIsPics(createdBranch) | translate }}
                                        </span>
                                    </div>
                                    <div class="d-flex w-100 zx-text-tiny zx-text-sm-small text-green opacity-75">
                                        <b>
                                            <span>
                                                {{ "main-nav.super-management-papers" | translate }}
                                            </span>
                                            <span>
                                                :
                                            </span>
                                        </b>
                                        <span class="zx-100-opp">-</span>
                                        <ng-container
                                            *ngFor="let paper of createdBranch.consumables.papers; let j = index">
                                            <div class="d-flex align-items-center">
                                                <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                    class="text-center">
                                                    {{ "paper-type.name-short." + paper.serial_name | translate }}
                                                </span>
                                                <span *ngIf="createdBranch.consumables.papers.length !== j + 1">
                                                    ,
                                                </span>
                                                <span class="zx-100-opp">-</span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- // EXPRESS -->
                    </div>
                    <!-- // BRANCHES BTNS -->

                </article>
            </article>

            <!-- action BTN -->
            <div *ngIf="branch !== '' && !isLoadingbranch" [class.show-main-btn]="isBranchSet"
                class="w-100 p-2 shadow-85-strong zx-z-index-1 hide-main-btn">
                <button type="button" mat-raised-button color="primary"
                    class="text-white rounded-pill w-100 zx-medium-btn zx-main-btn-effects fw-bold"
                    (click)="onSetBranch()">
                    <span class="d-sm-none" *ngIf="continueToPrinterText.length < 26">
                        {{ continueToPrinterText }}
                    </span>
                    <span class="d-sm-none" *ngIf="continueToPrinterText.length >= 26" [class.zx-ltr]="!isRTL">
                        <span>
                            {{ continueToPrinterText | slice:0:26 }}
                        </span>
                        <span>...</span>
                    </span>
                    <span class="d-none d-sm-flex justify-content-center">
                        {{ continueToPrinterText }}
                    </span>
                </button>
            </div>
            <!-- // action BTN -->

        </div>
        <!-- // CHOOSE BRANCH SIDE -->




        <!-- CANVAS SIDE -->
        <div class="d-none d-md-flex h-100 flex-grow-1 justify-content-center align-items-center"
            [class.bg-white]="!isDarkMode">
            <article
                class="zx-canvas shadow-85 rounded-3 d-flex justify-content-center align-items-center position-relative"
                [class.zx-canvas-dark]="isDarkMode">
                <article
                    class="w-100 flex-grow-1 d-flex flex-column align-items-center flex-shrink-0 justify-content-between pt-5 gap-5 px-lg-2 px-xl-3">

                    <!-- empty -->
                    <div *ngIf="hoveredPrintingService === ''"
                        class="w-100 d-flex flex-column align-items-center justify-content-center gap-2 pb-3">
                        <h6 class="zx-text-big fw-bold m-0 text-center" [class.zx-rtl]="isRTL">
                            {{ 'choose-system.empty' | translate }}
                        </h6>
                        <img [src]="'assets/images/system-empty.svg'" [alt]="'Choose Printing Service'"
                            class="zx-system-empty-icon">
                        <h2 class="zx-text-big m-0 text-center" [class.zx-rtl]="isRTL">
                            {{ 'choose-system.empty-explain' | translate }}
                        </h2>
                    </div>
                    <!-- // empty -->

                    <!-- syste hover -->
                    <div *ngIf="hoveredPrintingService !== ''"
                        class="w-100 d-flex flex-column align-items-center justify-content-center gap-2 pb-3">
                        <h6 class="zx-text-big fw-bold m-0 text-center" [class.zx-rtl]="isRTL">
                            {{ 'choose-system.printer.' + hoveredPrintingService | translate }}
                        </h6>
                        <img [src]="'assets/images/system-papers.svg'" [alt]="'Choose Printing Service'"
                            class="zx-system-papers-icon">
                        <h2 class="zx-text-medium m-0 text-center opacity-75 zx-lh-small px-4" [class.zx-rtl]="isRTL"
                            style="min-height: 70px;">
                            {{ 'choose-system.explanation-' + hoveredPrintingService | translate }}
                        </h2>
                    </div>
                    <!-- // syste hover -->

                </article>
            </article>
        </div>
        <!-- // CANVAS SIDE -->

    </div>
</div>